import React from "react";
import { useNavigate } from "react-router-dom";
import SideNav from "./Sidebar";
import TopNav from "./Header";
import Footer from "./Footer";
import { logoutUser } from "../API_Service/Login_Slice";
import { useDispatch } from "react-redux";

const DashboardLayout = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = React.useState(
    () => localStorage.getItem("sidebarCollapsed") === "true"
  );

  const handleToggle = () => {
    setCollapsed((prev) => {
      localStorage.setItem("sidebarCollapsed", String(!prev));
      return !prev;
    });
    // ApexCharts (dashboard) size themselves on window resize — fire one after
    // the 300ms sidebar transition so charts shrink/grow with the new width.
    setTimeout(() => window.dispatchEvent(new Event("resize")), 350);
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="flex bg-slate-50 min-h-screen">
      <SideNav collapsed={collapsed} onToggle={handleToggle} />

      <div
        className="flex-1 flex flex-col transition-all duration-300 min-w-0"
        style={{ marginLeft: collapsed ? "72px" : "256px" }}
      >
        <TopNav onLogout={handleLogout} />
        <main className="flex-1 min-w-0 overflow-x-hidden overflow-y-visible">{children}</main>
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;